import {
  default as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material/TextField';
import { styles } from './utils';

export interface TextFieldProps<N extends string> extends Omit<
  Partial<MuiTextFieldProps<'outlined'>>,
  'onChange'
> {
  error?: boolean;
  name: N;
  label: string;
  value: string;
  type?: 'text' | 'password' | 'email' | 'phone' | 'number';
  onChange: (update: Record<N, string>) => void;
}

export default function TextField<N extends string>({
  name,
  type = 'text',
  onChange,
  sx = {},
  ...props
}: TextFieldProps<N>) {
  return (
    <MuiTextField
      type={type}
      variant="outlined"
      color="grey-4"
      sx={{ ...styles.textField, ...sx }}
      onChange={(e) =>
        onChange({ [name]: e.target.value } as Record<N, string>)
      }
      {...props}
    />
  );
}
